import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import Loading from "../../loading";
import { qrRedirectUrl } from "../../../environment";
const ReuserCardQrGenerator = ({ id }) => {
  const [qr, setQr] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (id) generateQr(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  const generateQr = async (id) => {
    let response = "";
    try {
      response = await QRCode.toDataURL(
        `${qrRedirectUrl}?reuser_id=${id + ""}`
      );
    } catch (error) {}
    setQr(response);
    setLoading(false);
  };

  return (
    <>
      {!loading && qr !== "" && <img src={qr} alt="qr_code" />}
      {loading && !qr && <Loading width={25} height={25} />}
    </>
  );
};
export default ReuserCardQrGenerator;
